import type { DevEnv } from "@p0security/shared/types/environment";

import { CREATED_BY_CLOUD_SHELL, P0_TAG_NAME } from "../constants.ts";
import type { AwsPartition } from "../util.ts";
import { arnInfo } from "../util.ts";
import {
  functionCallerPolicy,
  functionCallerPolicyName,
  roleReaderPolicy,
} from "./policies.ts";
import { awsRoleName, buildGcpP0TrustPolicy } from "./shared.ts";

export const functionCallerInstallCommands = (
  context: DevEnv,
  args: {
    gcloudServiceAccountId: string;
    lambdaArn: string;
  }
) => {
  const roleName = awsRoleName(context, "function-caller");
  const info = arnInfo(args.lambdaArn);
  const { accountId, partition, name } = info;
  if (!accountId) {
    throw new Error("No account ID");
  }
  if (!name) {
    throw new Error("Lambda name could not be determined from ARN");
  }
  const policyName = functionCallerPolicyName(name);
  const policy = functionCallerPolicy(args);
  return installCommands({
    ...args,
    awsPartition: partition,
    policy,
    policyName,
    roleName,
    awsAccountId: accountId,
  });
};

const installCommands = (args: {
  awsPartition: AwsPartition;
  gcloudServiceAccountId: string;
  lambdaArn: string;
  policy: object;
  policyName: string;
  roleName: string;
  awsAccountId: string;
}) => {
  const trustPolicy = buildGcpP0TrustPolicy(args.gcloudServiceAccountId);
  const trustPolicyJson = JSON.stringify(trustPolicy, undefined, 2);
  const commands = `
CALLER=$(aws sts get-caller-identity --query Arn --output text) && \\
aws iam get-role --role-name "${
    args.roleName
  }" > /dev/null 2>&1 || aws iam create-role \\
  --tags Key="${P0_TAG_NAME}",Value="${CREATED_BY_CLOUD_SHELL} by \${CALLER}" \\
  --role-name "${args.roleName}" \\
  --assume-role-policy-document '${trustPolicyJson}'

aws iam put-role-policy \\
  --role-name "${args.roleName}" \\
  --policy-name "P0CanReadRolesPolicy" \\
  --policy-document '${JSON.stringify(roleReaderPolicy(args), undefined, 2)}'

aws iam put-role-policy \\
  --role-name "${args.roleName}" \\
  --policy-name "${args.policyName}" \\
  --policy-document '${JSON.stringify(args.policy, undefined, 2)}'
`;
  return commands.trim();
};
